export const baseUrl = {
  dev: "//dev.medtion.com",
  pro: "",
  ws: "//ws.medtion.com",
};
export const fwhAppId = 'wx39e8149ff76f5464'; // 授权用
export const gzhAppId = 'wx14e2e4ab1272b213'; // 分享用
export const searchHttp = '//search.medtion.com' // 搜索使用该域名
export const searchHttpDev = '//searchdev.medtion.com' // 搜索使用该域名
